
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_1ykar_1l1r1_13",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_1l1r1_1",
  "root": "awsui_root_1ykar_1l1r1_36",
  "calendar-inner": "awsui_calendar-inner_1ykar_1l1r1_74",
  "calendar-header": "awsui_calendar-header_1ykar_1l1r1_78",
  "calendar-header-title": "awsui_calendar-header-title_1ykar_1l1r1_83",
  "calendar-next-btn": "awsui_calendar-next-btn_1ykar_1l1r1_91",
  "calendar-prev-btn": "awsui_calendar-prev-btn_1ykar_1l1r1_94",
  "calendar-grid": "awsui_calendar-grid_1ykar_1l1r1_97",
  "calendar-grid-dense": "awsui_calendar-grid-dense_1ykar_1l1r1_101",
  "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_1l1r1_109",
  "calendar-date-header": "awsui_calendar-date-header_1ykar_1l1r1_114",
  "calendar-date": "awsui_calendar-date_1ykar_1l1r1_114",
  "calendar-date-enabled": "awsui_calendar-date-enabled_1ykar_1l1r1_134",
  "calendar-date-current-page": "awsui_calendar-date-current-page_1ykar_1l1r1_144",
  "calendar-date-selected": "awsui_calendar-date-selected_1ykar_1l1r1_155",
  "calendar-date-current": "awsui_calendar-date-current_1ykar_1l1r1_144",
  "calendar-date-dense": "awsui_calendar-date-dense_1ykar_1l1r1_176",
  "date-inner": "awsui_date-inner_1ykar_1l1r1_184",
  "calendar-row": "awsui_calendar-row_1ykar_1l1r1_259",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1ykar_1l1r1_263"
};
  